package gr.tech.GRAttestation.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.GRAttestation.styles.store.SuccessCheckmarkCircleStyle
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

@Composable
fun SuccessCheckmark() {
    Div(attrs = SuccessCheckmarkCircleStyle.toModifier().toAttrs()) {
        Text("✓")
    }
}
